var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoldPoint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFCC00",
    d: "M512 512m-512 0a512 512 0 1 0 1024 0 512 512 0 1 0-1024 0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M535.552 580.8896a19.7632 19.7632 0 0 1 17.9456 11.0592l69.888 142.8992a9.8816 9.8816 0 0 1-8.8064 14.2848H241.3568a9.8816 9.8816 0 0 1-9.6-12.5696l35.4816-140.7488a19.6864 19.6864 0 0 1 19.1232-14.9248h249.1648z m183.296-255.744c3.584 0 6.912 1.92 8.6528 5.0432l59.7248 103.2192c6.656 11.4176 7.1168 25.4208 1.2544 37.2736l-116.7616 236.9536a9.8816 9.8816 0 0 1-17.792-0.256l-62.8736-126.9248a39.5264 39.5264 0 0 1 0.896-36.5568l118.272-213.7088a9.8816 9.8816 0 0 1 8.6528-5.0432z m-39.936-50.2784a9.8816 9.8816 0 0 1 8.96 14.6432l-128.0768 231.4752c-6.912 12.6976-20.224 20.608-34.688 20.6592h-234.7008a9.8816 9.8816 0 0 1-8.448-14.9248l137.7792-232.448a39.424 39.424 0 0 1 33.9712-19.4048h225.1776z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoldPoint);
export default __webpack_public_path__ + "static/media/gold_point.1ef145b1e1571133ff4c199291550fa7.svg";
export { ForwardRef as ReactComponent };